import React, { useEffect, useState } from "react";

import Input from "../../../../UI/Input/Input";
import { checkValidity } from "../../../../shared/utility";
import classes from "./Basics.css";
import { timeZones } from "../../../../shared/Constants";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import Message from "../../../../components/Message/Message";
import moment from "moment";

const Basics = (props) => {
  const [valid, setValid] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [basicsForm, setBasicsForm] = useState({
    date: {
      elementType: "input",
      elementConfig: {
        type: "date",
        id: "date",
      },
      value: "",
      validation: {
        required: true,
        minLength: 5,
        maxLength: 10,
        pattern: "[0-9]",
        restrictFuture: true,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: true,
      touched: false,
      label: "Issue Reported Date",
      inputType: "QuickSearch",
    },
    time: {
      elementType: "input",
      elementConfig: {
        type: "time",
        id: "time",
      },
      value: "",
      validation: {
        required: true,
        minLength: 7,
        maxLength: 7,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: true,
      touched: false,
      label: "Issue Reported Time",
      inputType: "QuickSearch",
    },
    timeZone: {
      elementType: "select",
      elementConfig: {
        type: "text",
        id: "timeZone",
        placeholder: "Select One",
        options: timeZones.map((zones) => ({
          value: zones.label,
          displayValue: zones.label,
        })),
      },
      value: "",
      validation: {
        required: true,
        minLength: 1,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: true,
      label: "Time Zone",
      touched: false,
      inputType: "QuickSearch",
    },
    priority: {
      elementType: "select",
      elementConfig: {
        type: "text",
        id: "priority",
        placeholder: "Select One",
        options: [{
          value: 3,
          displayValue: 3,
        },{
          value: 4,
          displayValue: 4,
        },{
          value: 5,
          displayValue: 5,
        }],
      },
      value: 4,
      validation: {
        required: true,
        minLength: 1,
      },
      disabled: false,
      valid: true,
      label: "Priority",
      touched: false,
      inputType: "QuickSearch",
    },
  });

    const getDefaultTimeValues=()=>{
      let timeZoneOffset = new Date().getTimezoneOffset();
        const symbl = timeZoneOffset < 0 ? "+" : "-";
        if (timeZoneOffset < 0) timeZoneOffset *= -1;
        const time = String(timeZoneOffset / 60);
        const hours = "0" + time.split(".")[0];
        const minutes = time.split(".")[1]
          ? parseInt(time.split(".")[1]) * 6
          : "00";
        const timeZone =
          "GMT" +
          symbl +
          +hours +
          ":" +
          minutes +
          " " +
          Intl.DateTimeFormat().resolvedOptions().timeZone;
          const date = moment().format('YYYY-MM-DD');
          const todayTime = moment().format('hh:ss');
          return {
            timeZone, date, todayTime
          }
    }


    const setDefaultTimeValues=()=>{
      const form = { ...basicsForm };
      const {timeZone, date, todayTime} = getDefaultTimeValues();
      if (props.impactedMemberData) {
        form.date.value = props.impactedMemberData.issueOccurredTs
          ? props.impactedMemberData.issueOccurredTs.split("T")[0]
          : date;
        form.time.value = props.impactedMemberData.issueOccurredTs
          ? props.impactedMemberData.issueOccurredTs.split("T")[1]
          : todayTime;
        form.timeZone.value = props.impactedMemberData.issueOccurredTimeZone || timeZone;
      } else {
        form.date.value = date;
        form.time.value = todayTime;
        form.timeZone.value = timeZone;
      }
      return form;
    }

  useEffect(() => {
    const updatedForm = setDefaultTimeValues();
    setBasicsForm(updatedForm);
    props.setBasicDetails(updatedForm);
  }, []);

  useEffect(() => {
    if (
      basicsForm.time.valid &&
      basicsForm.date.valid &&
      basicsForm.timeZone.valid
    ) {
      props.isValid(true);
    } else {
      props.isValid(false);
    }
  }, [basicsForm]);

    useEffect(()=>{
      const updatedForm = {}
      Object.keys(basicsForm)
      .map((key)=>{
        const formCopy = {...basicsForm[key]};
        formCopy.disabled = props.formDisabled;
        updatedForm[key]= formCopy;
      })
      setBasicsForm(updatedForm)
    },[props.formDisabled])

    useEffect(()=>{
      const updatedForm = setDefaultTimeValues();
      Object.keys(basicsForm)
      .map((key)=>{
        const formCopy = {...basicsForm[key]};
        formCopy.disabled = false;
        updatedForm[key]= formCopy;
      })
      updatedForm.priority.value = 4;
      setBasicsForm(updatedForm);
      props.setBasicDetails(updatedForm);
    },[props.resetValues])

  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...basicsForm };
    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    updatedFormElement.value = event.target.value;
    let formIsValid = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    if (event.target.value) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
      setErrorMsg({ message: validation.message });
    } else {
      updatedFormElement.valid = false;
    }
    setValid(updatedFormElement.valid);
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }
    setBasicsForm(updatedForm);
    props.setBasicDetails(updatedForm);
  };

  const basicsFormDisplay = (
    <div className={classes.formLayout}>
      {Object.keys(basicsForm).map((key) => (
        <Input
          key={key}
          elementType={basicsForm[key].elementType}
          elementConfig={basicsForm[key].elementConfig}
          value={basicsForm[key].value}
          invalid={!basicsForm[key].valid}
          shouldValidate={basicsForm[key].validation}
          touched={basicsForm[key].touched}
          disabled={basicsForm[key].disabled}
          label={basicsForm[key].label}
          changed={(event) => inputChangedHandler(event, key)}
          inputType={basicsForm[key].inputType}
        />
      ))}
    </div>
  );

  return (
    <>
      <div className={classes.FormTitle}>{"Event Details"}
          &nbsp;<a data-tip data-for='event'><span className="fa fa-question-circle"></span> </a>
          <ReactTooltip id='event'>
            <span>Provide the details of when the event was discovered</span>
          </ReactTooltip>
      </div>
      <div className={classes.box}>
        <Message msgType="Error" info={errorMsg} />
        {basicsFormDisplay}
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    impactedMemberData: state.member.impactedMemberData,
  };
};

export default connect(mapStateToProps, null)(Basics);